import type { DetailedPricingPackage } from '../../../jotai/storefront/detailed-pricing';

export type ServicesGrouped = {
	[groupName: string]: string[];
};

export const usePackageServices = (
	pkg: DetailedPricingPackage,
): ServicesGrouped => {
	const capitalizeFirst = (str: string) =>
		str.charAt(0).toUpperCase() + str.slice(1);

	const groups: Record<string, string[]> = {};

	if (pkg.presetServices?.length) {
		for (const { description, serviceType } of pkg.presetServices) {
			const key = capitalizeFirst(serviceType ?? '');
			if (!groups[key]) {
				groups[key] = [];
			}
			if (description != null) {
				groups[key].push(description);
			}
		}
	}

	if (pkg.services?.length) {
		groups.Services = pkg.services;
	}

	return groups;
};
